import React, {Component} from 'react';
import AdminTitle from '../../components/AdminTitle';
import Button from '../../components/Button';
import Api from '../../Api';
import FontAwesome from 'react-fontawesome';

import {optionTree} from '../../lib/AdminFunctions';

export default class AdminProduct extends Component {
  constructor() {
    super();

    this.refreshProduct = this.refreshProduct.bind(this);

    this.state = {
      brand: null,
      product: null
    };
  }

  refreshProduct() {
    Api.getProductCache(this.props.params.productToken)
      .then(
        (response) => {
          let product = response.products[this.props.params.productToken];
          let brand = response.brands[product.brand_token];

          this.setState({product, brand});
        }
      );
  }

  componentWillMount() {
    this.refreshProduct();
    Api.cache.addChangeListener(this.refreshProduct, Api.cache.eventTypes.PRODUCTS_CHANGED);
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.refreshProduct, Api.cache.eventTypes.PRODUCTS_CHANGED);
  }

  render() {
    if (!this.state.brand || !this.state.product) {
      return (<div className="page-loading"><FontAwesome name="circle-o-notch" spin/></div>);
    }
    let brand = this.state.brand;
    let product = this.state.product;

    let categories = (product.categories || []).join(', ');

    let images = (product.images || []).map((image) => {
      let imageUrl = image.url.indexOf('http') === 0 ? image.url : 'http://' + image.url;
      let imageKey = image !== null ? image.token : null;
      return (<img className="admin-product-thumbnail" key={imageKey} src={imageUrl} alt={product.name}/>);
    });

    let options = optionTree(this.state.brand.token, this.state.product);

    return (
      <div>
        <AdminTitle title={brand.name + ' / ' + product.name}>
          <Button to={'/admin/brand/' + brand.token}>Back to brand</Button>
          <Button to={'/admin/brand/' + brand.token + '/product/' + product.token + '/edit'}>Edit Product</Button>
        </AdminTitle>
        <div className="admin-product">
          <div className="admin-product-section">
            <h1>{product.name}</h1>
            <p className="short-description">{product.short_description}</p>
            <p className="description">{product.description}</p>
            <div className="categories">{categories}</div>
          </div>

          <div className="admin-product-thumbnails admin-product-section">{images}</div>

          <div className="options">
            <h2>Options</h2>
            <div>{options}</div>
            <div><Button to={'/admin/brand/' + brand.token + '/product/' + product.token + '/option/new'}>Add
              Option</Button></div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminProduct.js
 **/